import React from 'react';

const ComponentChangePassword = () => {
  return (
    <div>
      ComponentChangePassword
    </div>
  );
};

export default ComponentChangePassword;